<!--
 Created by Xuz on 2019/01/24.
 xuz[at]live[dot]cn
 流程下一步操作
-->
<template>
    <a-modal title="操作成功"
             class="wf-modal"
             :destroyOnClose="true"
             :width="1065"
             :footer="null"
             :visible="visible"
             :maskClosable="false"
             @cancel="onCancel">
        <div class="result">
            <div>
                <a-icon class="icon success" type="check-circle"/>
            </div>
            <div class="title">{{result.title}}</div>
            <div v-html="result.desc" class="description"></div>
            <!--<div class="content"></div>-->
            <div class="action">
                <a-button @click="onClose" :style="{ fontSize: '16px', color: '#19ECFF' }">关闭窗口</a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
export default {
  name: 'ResultAccuss',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  created () {
  },
  data () {
    return {
      counter: null,
      result: {
        title: '',
        desc: ''
      }
    }
  },
  watch: {},
  methods: {
    process () {
      const that = this
      let count = 3
      that.result.desc = that.getCounterDesc(count)
      that.counter = setInterval(() => {
        console.log(count)
        if (--count <= 0) {
          that.onClose()
        } else {
          that.result.desc = that.getCounterDesc(count)
        }
      }, 1000)
    },
    onCancel () {
      clearInterval(this.counter)
      this.$emit('cancel')
    },
    onClose () {
      clearInterval(this.counter)
      this.$emit('cancel')
    },
    getCounterDesc (count) {
      return '本窗口 <span style="color:red">' + count + '</span> 秒后自动关闭'
    }
  }
}
</script>

<style>
    .wf-modal .ant-modal-body {
        padding: 12px !important;
    }

    .wf-card .ant-card-body {
        padding: 0 !important;
    }

    .wf-card-title {
        border-width: 1px 1px 0 1px;
        border-style: solid;
        border-color: #b2d5f2;
        background-color: #e2f2ff;
        padding: 8px;
    }

    .wf-card-body {
        height: 280px;
        overflow-y: auto;
        border: 1px solid #b2d5f2;
        padding: 5px;
    }

    .wf-cards {
        display: flex;
        flex-wrap: wrap;
    }

    .wf-modal .ant-modal-header {
        padding: 16px 24px;
        border-radius: 4px 4px 0 0;
        color: rgba(0,0,0,.65);
        border-bottom: 1px solid #e8e8e8;
        background: #2f7fe3;
    }

    .wf-modal .ant-modal-title {
        color: #fff;
    }

    .wf-modal .ant-modal-close-x {
        color: #fff;
    }
</style>

<style lang="less" scoped>
    .wf-cards {
        /deep/ .ant-checkbox-wrapper {
            height: auto;
            padding: 2px 0;
        }

        /deep/ .ant-radio-wrapper {
            height: auto;
            padding: 2px 0;
        }

        /deep/ .ant-radio-wrapper span {
            white-space: initial;
        }
    }

    .result {
        text-align: center;
        width: 72%;
        margin: 0 auto;
        padding: 24px 0 8px;

        .icon {
            font-size: 72px;
            line-height: 72px;
            margin-bottom: 24px;
        }
        .success {
            color: #52c41a;
        }
        .error {
            color: red;
        }
        .title {
            font-size: 24px;
            color: #fafafa;
            /*color: rgba(0, 0, 0, .85);*/
            font-weight: 500;
            line-height: 32px;
            margin-bottom: 16px;
        }
        .description {
            font-size: 14px;
            line-height: 22px;
            color: #fafafa;
            /*color: rgba(0, 0, 0, 0.45);*/
            margin-bottom: 24px;
        }
        .content {
            background: #fafafa;
            padding: 24px 40px;
            border-radius: 2px;
            text-align: left;
        }
        .action {
            margin-top: 32px;
        }
    }

    /deep/ .ant-modal-header {
        padding: 16px 24px;
        border-radius: 4px 4px 0 0;
        color: rgba(0,0,0,.65);
        border-bottom: 1px solid #e8e8e8;
        background: #2f7fe3;
    }
</style>
